import BaseService from '@/service/modules/BaseService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import axios from '@/axios'
import UserInfo from '@/model/modules/UserInfo'
import UserChargeInfo from '@/model/modules/UserChargeInfo'
import StorageKeyDefineLogin from '@/define/storage/login'
import UserBillInfo from '@/model/modules/UserBillInfo'

export default class UserInfoService extends BaseService {
  protected static baseUrl: string = '/user'

  public static list(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<UserInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<UserInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/user-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<UserInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }

  /**
   * 充值
   * @param chargeInfo
   */
  public static charge(chargeInfo: UserChargeInfo): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      axios.post(this.baseUrl + '/recharge', chargeInfo)
        .then(resp => {
          resolve()
        })
        .catch(e => {
          reject(e)
        })
    })
  }

  /**
   * 获取当前已登录用户的信息
   */
  public static getCurrentUserInfo(): Promise<UserInfo> {
    return this.getInfo(this.getCurrentUserId())
  }

  public static getCurrentUserId(): string {
    return sessionStorage[StorageKeyDefineLogin.LOGIN_USER_ID]
  }

  public static getCurrentUserBillInfoList(example: { [index: string]: any }, pageNum: number, pageSize: number): Promise<BasePageableInfo<UserBillInfo>> {
    example.page = pageNum
    example.size = pageSize
    return new Promise<BasePageableInfo<UserBillInfo>>((resolve, reject) => {
      axios.get(this.baseUrl + '/userBill-list', {
        params: example
      }).then(resp => {
        const result: BasePageableInfo<UserBillInfo> = new BasePageableInfo()
        result.count = resp.data.body.totalElements
        result.dataList = resp.data.body.content
        resolve(result)
      })
    })
  }
}
